'use strict';

var _ = require('lodash');
var EventMixin = require('./mixins/EventMixin');

function Draw (map, options, Actions, Store) {
  this.map = map;
  this._options = options;
  this._draw = null; // active draw
  this._drawOptions = this._getDrawOptions(options); // default drawOptions
  this.Actions = Actions;
  this.Store = Store;
}

Draw.create = function () {
  var inst = Object.create(this.prototype);
  var obj = this.apply(inst, arguments);
  return Object(obj) === obj ? obj : inst;
};

Draw.extend = function (protoProps, staticProps) {
  var parent = this;
  var child;

  // Setup the child constructor
  if (protoProps && _.has(protoProps, 'constructor')) {
    child = protoProps.constructor;
  } else {
    child = function () {
      return parent.apply(this, arguments);
    };
  }

  _.extend(child, parent, staticProps);

  var Surrogate = function () {
    this.constructor = child;
  };

  Surrogate.prototype = parent.prototype;
  child.prototype = new Surrogate();

  if (protoProps) {
    if (_.isArray(protoProps)) {
      _.extend.apply(null, [child.prototype].concat(protoProps));
    } else {
      _.extend(child.prototype, protoProps);
    }
  }

  child.__super__ = parent.prototype;
  return child;
};

/**
 * Merge passed in options with defaults
 * 
 * @param  {Object} options format should be exactly what Leaflet.draw expects
 * @return {Object} merged options
 */
Draw.prototype._getDrawOptions = function (options) {
  var drawOptions = {};

  if (options) {
    var keys = this.drawOptionKeys;
    drawOptions = _.reduce(keys, function (_opts, key) {
      if (options[key] !== undefined) {
        _opts[key] = options[key];
      }
      return _opts;
    }, drawOptions);
  }

  return drawOptions;
};

/**
 * Create a new draw instance
 *
 * @param {Object} options Leaflet.draw shape draw options
 */
Draw.prototype._newDraw = function (options) {
  /* jshint unused:false */
  // child override
};

/**
 * Enable drawing
 *
 * @return {Object} draw instance
 */
Draw.prototype.enable = function () {
  var drawOptions = this._drawOptions;

  this._draw = this._newDraw(drawOptions);
  this._draw.enable();

  // Add Custom Listeners
  this._registerEventListeners();
  
  return this._draw;
};

Draw.prototype.disable = function () {
  if (this._draw) {
    
    // Remove Custom Listeners
    this._removeEventListeners();

    this._draw.disable();
    this._draw = null;
  }
};

Draw.prototype.showError = function (message) {
  this._draw.options.drawError.message = message;
  this._draw._showErrorTooltip();
};

_.extend(Draw.prototype, EventMixin);

module.exports = Draw;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/draw/handlers/Draw.js